import PropTypes from 'prop-types'
import {
  StyledDownloadMenu,
  DownloadMenuHeader,
  DownloadMenuTitle,
  CompactMenuItem,
  CompactMenuItemText,
  downloadMenuListProps
} from '../ChatbotStyles'
import {hasDownloadableData} from '../utils/chatUtils'

const DownloadMenus = ({
  canExport,
  chartDownloadMenuAnchor,
  handleChartDownloadMenuClose,
  messages,
  selectedChartMessageId,
  handleChartDownloadSelection,
  downloadMenuAnchor,
  handleDownloadMenuClose,
  selectedDownloadMessageId,
  handleDownloadSelection
}) => {
  if (!canExport) {
    return null
  }

  return (
    <>
      <StyledDownloadMenu
        anchorEl={chartDownloadMenuAnchor}
        open={Boolean(chartDownloadMenuAnchor)}
        onClose={handleChartDownloadMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        MenuListProps={downloadMenuListProps}
      >
        <DownloadMenuHeader>
          <DownloadMenuTitle>Export as</DownloadMenuTitle>
        </DownloadMenuHeader>

        <CompactMenuItem
          onClick={() => {
            const msgObj = messages.find((msg) => msg.id === selectedChartMessageId)
            if (msgObj) handleChartDownloadSelection('png', msgObj)
          }}
        >
          <CompactMenuItemText primary='PNG' />
        </CompactMenuItem>

        {(() => {
          const msgObj = messages.find((msg) => msg.id === selectedChartMessageId)
          return msgObj && hasDownloadableData(msgObj) ? (
            <CompactMenuItem onClick={() => handleChartDownloadSelection('csv', msgObj)}>
              <CompactMenuItemText primary='CSV' />
            </CompactMenuItem>
          ) : null
        })()}
      </StyledDownloadMenu>

      <StyledDownloadMenu
        anchorEl={downloadMenuAnchor}
        open={Boolean(downloadMenuAnchor)}
        onClose={handleDownloadMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        MenuListProps={downloadMenuListProps}
      >
        <DownloadMenuHeader>
          <DownloadMenuTitle>Export as</DownloadMenuTitle>
        </DownloadMenuHeader>

        {(() => {
          const msgObj = messages.find((msg) => msg.id === selectedDownloadMessageId)
          return msgObj && hasDownloadableData(msgObj) ? (
            <CompactMenuItem onClick={() => handleDownloadSelection('csv', msgObj)}>
              <CompactMenuItemText primary='CSV' />
            </CompactMenuItem>
          ) : null
        })()}
      </StyledDownloadMenu>
    </>
  )
}

DownloadMenus.propTypes = {
  canExport: PropTypes.bool.isRequired,
  chartDownloadMenuAnchor: PropTypes.object,
  handleChartDownloadMenuClose: PropTypes.func.isRequired,
  messages: PropTypes.array.isRequired,
  selectedChartMessageId: PropTypes.string,
  handleChartDownloadSelection: PropTypes.func.isRequired,
  downloadMenuAnchor: PropTypes.object,
  handleDownloadMenuClose: PropTypes.func.isRequired,
  selectedDownloadMessageId: PropTypes.string,
  handleDownloadSelection: PropTypes.func.isRequired
}

export default DownloadMenus

/*
DOWNLOAD MENUS COMPONENT

KEY FUNCTIONS:
- handleChartDownloadSelection: Processes chart export requests (PNG/CSV)
- handleDownloadSelection: Handles data table CSV exports
- handleChartDownloadMenuClose/handleDownloadMenuClose: Menu state management
- hasDownloadableData: Validates if content can be exported

FEATURES:
- Conditional menu items based on data availability
- Proper anchor positioning relative to trigger buttons
- Permission-gated functionality (canExport prop)
- Dynamic content validation before showing options
*/
